import React, { useCallback } from 'react';
import { useMutation, useQuery } from '@apollo/client';
import { useSelector } from 'react-redux';
import { VendorProfile } from '@trnsact/trnsact-shared-types';

import { VendorProfileSettingsContainerRenderProps } from '../../portalConfigurations/types';
import { M_UPDATE_VP } from 'queries/common';
import _ from 'lodash';
import { useNotifications } from 'modules/notification';
import { GET_VP_SETTINGS } from '../api/getVendorProfileSettings';

interface Props {
  children: (options: VendorProfileSettingsContainerRenderProps) => React.ReactNode;
}

export const VendorProfileSettingsContainer = ({ children }: Props) => {
  const vendorProfile = useSelector<any, VendorProfile>(state => state.vp);

  const { showNotification } = useNotifications();

  const { data: vpSettingsData } = useQuery(GET_VP_SETTINGS, {
    variables: {
      dynamicsId: vendorProfile.dynamicsId,
    },
    fetchPolicy: 'no-cache',
  });

  const [updateVP, { loading: isUpdateVPLoading }] = useMutation(M_UPDATE_VP, {
    context: { authRequired: true },
    onCompleted() {
      showNotification('Changes Saved');
    },
    onError() {
      showNotification('Error on saving', { type: 'error' });
    },
  });

  const updateVPDebounced = useCallback(_.debounce(updateVP, 500), []);

  const handleSaveVendorProfile = async (fieldsObj: any) => {
    try {
      await updateVPDebounced({
        variables: {
          entityId: vendorProfile.id,
          fieldsObj,
        },
      });
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <>
      {vpSettingsData &&
        children({
          vpSettings: vpSettingsData.vendorProfile,
          loading: isUpdateVPLoading,
          onSaveVendorProfile: handleSaveVendorProfile,
        })}
    </>
  );
};
